import { createApp, h } from "vue";
import messageModal from "@/components/modals/MessageModal.vue";
import confirmInvoiceModal from "@/components/modals/ConfirmInvoiceModal.vue";
import ImagePlugin from "@/plugins/imagePlugin";

export default function (options, defautType) {
  return new Promise((resolve) => {
    const container = document.createElement("div");
    document.body.appendChild(container);

    const app = createApp({
      data() {
        return {
          visible: false,
        };
      },
      methods: {
        handleConfirm() {
          resolve(true);
          this.close();
        },
        handleCancel() {
          resolve(false);
          this.close();
        },
        handleConfirmInvoice(type) {
          resolve({ isConfirmed: true, type: type });
          this.close();
        },
        handleCancelInvoice() {
          resolve({ result: false });
          this.close();
        },
        close() {
          this.visible = false;
          setTimeout(() => {
            app.unmount();
            container.remove();
          }, 300); // 等動畫結束
        },
      },
      mounted() {
        this.$nextTick(() => {
          this.visible = true;
        });
      },
      render() {
        if (options.type === "confirmInvoice") {
          return h(confirmInvoiceModal, {
            trigger: this.visible,
            defaultType: defautType,
            onConfirm: this.handleConfirmInvoice,
            onCancel: this.handleCancelInvoice,
          });
        } else {
          return h(messageModal, {
            visible: this.visible,
            type: options.type || "alert",
            mainMessage: options.mainMessage,
            subMessage: options.subMessage || "",
            showCancel: options.showCancel || false,
            confirmOnly: options.confirmOnly || false,
            confirmText: options.confirmText || "確定",
            cancelText: options.cancelText || "取消",
            onConfirm: this.handleConfirm,
            onCancel: this.handleCancel,
          });
        }
      },
    });

    app.use(ImagePlugin);
    app.mount(container);
  });
}
